import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const sessionId = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data.user);
        const path = data.user.role === "admin" ? "/admin/dashboard" : data.user.role === "agency" ? "/dashboard/agency" : data.user.role === "independent" ? "/dashboard/independent" : "/dashboard/client";
        window.history.replaceState(null, "", "/");
        nav(path);
      } catch {
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return <div className="min-h-screen flex items-center justify-center text-[#737373]" data-testid="auth-callback">Signing you in…</div>;
}
